export const LogoFarmaxmp = ({ className = "w-10 h-10" }) => {
  return (
    <svg 
      viewBox="0 0 100 100" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="#2563eb" />
      
      {/* Cross/Plus symbol */}
      <rect x="44" y="20" width="12" height="60" rx="2" fill="white" />
      <rect x="20" y="44" width="60" height="12" rx="2" fill="white" />
      
      {/* Pill shape left */}
      <ellipse cx="35" cy="35" rx="8" ry="5" fill="#60a5fa" transform="rotate(-45 35 35)" />
      
      {/* Pill shape right */}
      <ellipse cx="65" cy="65" rx="8" ry="5" fill="#60a5fa" transform="rotate(-45 65 65)" />
    </svg>
  );
};

export const LogoFarmaxmpFull = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoFarmaxmp className="w-10 h-10" />
      <div>
        <h1 className="font-heading font-bold text-lg text-slate-900">FARMAXMP</h1>
        <p className="text-xs text-slate-500">Produtos Farmacêuticos</p>
      </div>
    </div>
  );
};

export default LogoFarmaxmp;
